import { useTranslation } from "react-i18next";
import ExternalActionBanner from "components/ExternalActionBanner/ExternalActionBanner";
import { E_CONSULTATION_URL } from "config/ExternalLinksConfig";

const ConsultationBanner = () => {
  const { t } = useTranslation();

  return (
    <ExternalActionBanner headingId="home-consultation-title"
      title={t("view.homePage.consultation.title")}
      description={t("view.homePage.consultation.description")}
      href={E_CONSULTATION_URL}
      actionText="e-consultare.gov.ro"
      linkLabel={t("view.homePage.consultation.linkLabel")} />
  );
};

export default ConsultationBanner;
